import { boolean, date, mixed, number, object, string } from 'yup'

const jobSchema = (type: 'internship' | 'others' = 'others') =>
  object().shape({
    pipeline: number()
      .min(1, 'Please Select a pipeline')
      .required('pipeline must be selected'),
    description: string().min(3).required('Specify a short Description'),
    paid:
      type === 'others'
        ? mixed().notRequired()
        : boolean().required('is this internship paid or not'),
    title: string().min(2).required('Enter a representative title'),
    job_type:
      type === 'others'
        ? string().min(3).required('Select a job type')
        : mixed().notRequired(),
    work_policy: string().min(3).required('Specify a work policy'),
    salary_currency: mixed().when(['min_salary_range', 'max_salary_range'], {
      is: (min: any, max: any) => !!min || !!max, // Check if either value is provided
      then: string().required('Select a currency'),
      otherwise: mixed().notRequired(),
    }),
    min_salary_range: mixed().notRequired(),
    max_salary_range: mixed().notRequired(),

    years_of_experience: number()
      .min(0, 'Please enter a number of years greater than or equal to 0.')
      .required('Please enter a valid number of years'),
    location: string().min(2).required('Enter the location of the job'),
    closed_date: date()
      .min(new Date())
      .required('Pick a closing date for this job'),
  })

export default jobSchema
